import {combineReducers} from 'redux';
import authReducer from './auth/authReducer';
import companyReducer from './company/companyReducer';
import clientsReducer from './clients/clientsReducer';
import employeeReducer from './employee/employeeReducer';
import countriesReducer from './countries/countriesReducer';
import mailingReducer from './mailing/mailingReducer';
import appReducer from './app/appReducer';
import ProjectsReducer from './projects/projectsReducer';
import ProfileReducer from './profile/profileReducer';
import ReportsReducer from './reports/reportsReducer';
import documentReducer from './documents/documentReducer';
import dictionariesReducer from './dictionaries/dictionariesReducer';
import chatReducer from './chat/chatReducer';

const mainReducer = () =>
    combineReducers({
        profile: ProfileReducer,
        auth: authReducer,
        app: appReducer,
        company: companyReducer,
        clients: clientsReducer,
        employee: employeeReducer,
        countries: countriesReducer,
        mailing: mailingReducer,
        projects: ProjectsReducer,
        reports: ReportsReducer,
        documents: documentReducer,
        dictionaries: dictionariesReducer,
        chat: chatReducer
    });

const rootReducer = (history) => (state, action) => {
    if (action.type === 'LOG_OUT') {
        // Clear all states except for router
        state = {router: state.router};
    }

    return mainReducer(history)(state, action);
};

export default rootReducer;
